<label
  class="fdz"
  [class.fdz--dragging]="dragging()"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <input
    type="file"
    class="fdz__input"
    [accept]="accept()"
    [attr.aria-label]="'fileDropzone.clickToUpload' | translate"
    (change)="onFileSelect($event)"
  />
  <span class="fdz__icon" aria-hidden="true">
    <mat-icon>cloud_upload</mat-icon>
  </span>
  <span class="fdz__cta">
    <span class="fdz__cta-link">{{ 'fileDropzone.clickToUpload' | translate }}</span>
    <span class="fdz__cta-rest">{{ 'fileDropzone.orDragDrop' | translate }}</span>
  </span>
  @if (hint()) {
    <span class="fdz__hint">{{ hint() }}</span>
  }
</label>

@if (file(); as selected) {
  <div class="fdz-file">
    <span class="fdz-file__icon" aria-hidden="true">
      <mat-icon>description</mat-icon>
    </span>
    <span class="fdz-file__meta">
      <span class="fdz-file__name">{{ selected.name }}</span>
      <span class="fdz-file__size">{{ formatSize(selected.size) }}</span>
    </span>
    <button
      type="button"
      class="fdz-file__remove"
      [attr.aria-label]="'fileDropzone.remove' | translate"
      (click)="clear()"
    >
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
}
